import React, { Component, Fragment } from 'react';
import _get from 'lodash/get';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import {orange500} from 'material-ui/styles/colors';

import BaseRegion from '../Base/region';

export default class Region extends BaseRegion {

  render() {
    let { data: { region, dwtGroup }, unfold = true, errors, askingForSaveWWR } = this.state;
    let { dwtGroups, tcRates } = this.props;

    return (
      <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
        <Dialog
          title='Are you sure?'
          actions={[
            <FlatButton
              label='Ok'
              primary
              onClick={() => {
                this.save();
                this.toggleState('askingForSaveWWR');
              }}
            />,
            <FlatButton
              label='Cancel'
              primary
              onClick={() => this.toggleState('askingForSaveWWR')}
            />
          ]}
          open={askingForSaveWWR}
          autoScrollBodyContent
          modal
        >
          <p>Are you sure you want to save wwr region? All other regions will be recalculated</p>
        </Dialog>
        <TableRowColumn style={{width: '20%'}}>
          {
            unfold ?
              <Fragment>
                <p>{region.name || 'no name'}</p>
                <DropDownMenu
                  value={'askForSave'}
                  style={{padding: 0}}
                  onChange={(e, key, handler) => this[handler]()}
                >
                  <MenuItem value='askForSave' primaryText="save" />
                  {
                    !this.isWWR() &&
                      [
                        <MenuItem value='recalculate' primaryText="recalculate" key={1} />,
                        <MenuItem value='remove' primaryText="remove" key={2} />
                      ]
                  }
                </DropDownMenu>
              </Fragment>
            :
              <p
                onClick={this.toggleUnfold}
                style={{cursor: 'pointer'}}
              >
                {region.name || 'no name'}
              </p>
          }
        </TableRowColumn>

        {
          unfold ?
            <Fragment>
              <TableRowColumn style={{width: '20%', padding: 0}}>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroups).map((key, i) => {
                        return (
                          <TableRow key={`dwt-group-name-${i}`}>
                            <TableRowColumn>
                              {dwtGroups[key]}
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>

              <TableRowColumn style={{width: '10%', padding: 0}}>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroup).map((key, i) => {
                        return (
                          <TableRow key={`dwt-group-percent-${i}`}>
                            <TableRowColumn>
                              <TextField
                                value={dwtGroup[key].percentToWW}
                                hintText='0'
                                onChange={(e, value) => this.handleChange([{key: `dwtGroup.${key}.percentToWW`, value}])}
                                fullWidth
                                errorText={errors[`dwtGroup.${key}.percentToWW`] ? 'required' : ''}
                                disabled={this.isWWR()}
                              />
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>

              <TableRowColumn style={{width: '50%', padding: 0}}>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroup).map((key, j) => {
                        let markEditedByUser = dwtGroup[key].tcRatesDay.editedByUser ? {
                          underlineFocusStyle: {borderColor: orange500},
                          underlineStyle: {borderColor: orange500}
                        } : {}

                        return (
                          <TableRow key={`tc-rate-${j}`}>
                            <TableRowColumn>
                              <TextField
                                value={dwtGroup[key].tcRatesDay.value}
                                hintText='0'
                                onChange={(e, value) => {
                                  let changes = [{key: `dwtGroup.${key}.tcRatesDay.value`, value}];
                                  if (!dwtGroup[key].tcRatesDay.editedByUser) {
                                    changes.push({key: `dwtGroup.${key}.tcRatesDay.editedByUser`, value: true, noError: true})
                                  }
                                  this.handleChange(changes)
                                }}
                                fullWidth
                                errorText={errors[`dwtGroup.${key}.tcRatesDay.value`] ? 'required' : ''}
                                {...markEditedByUser}
                              />
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>
            </Fragment>
          :
            <Fragment>
              <TableRowColumn style={{width: '20%', padding: 0}}>
              </TableRowColumn>
              <TableRowColumn style={{width: '10%', padding: 0}}>
              </TableRowColumn>
              <TableRowColumn style={{width: '50%', padding: 0}}>
              </TableRowColumn>
            </Fragment>
        }


      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/TimeCharter/Bulk/region.js